<template>
  <header class="ag-header">
    <h1 class="ag-header__title">{{title}}</h1>
    <div class="ag-header__body">
      <!-- header body used for icons in mobile only layouts -->
      <slot />
    </div>
  </header>
</template>

<script>
/**
 * @vuese
 * header component used on standalone/standalone pages
 */
export default {
  name: 'ag-header',
  props: {
    // content for h1 element
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.ag-header {
  padding: 0;
  margin-bottom: rem(10px);

  @include mq($mq-large) {
    padding: 0;
    margin-bottom: rem(30px);
  }

  &__title {
    font-size: rem(20px);
    line-height: 1.25;
    color: $primary-color;
    margin: 0 0 rem(8px);
    font-weight: 400;

    @include mq($mq-large) {
      font-size: rem(32px);
      margin: 0 0 rem(20px);
    }
  }

  &__body {
    font-size: rem(15px);
    font-weight: 600;
    line-height: 1.5;
    display: flex;
    flex-direction: column;

    @include mq($mq-large) {
      display: block;
    }
  }
}
</style>
